import { useCallback } from 'react';
import type { EventListItemType } from 'features/events';
import type { EventItem } from '../DeclinedEvents';

export const useCreateEventListItem = () =>
  useCallback(({ item: { event, source } }: { item: EventItem }): EventListItemType => {
    if (source === 'rails') {
      return event;
    }

    return {
      endTime: event.endTime,
      eventType: event.type,
      goingInviteesCount: event.participants.filter((participant) => participant.rsvp === 'going').length,
      id: event.id,
      name: event.name,
      recordingStatus: event.recording?.status,
      startTime: event.startTime,
      status: event.status,
    };
  }, []);
